module.exports = __webpack_public_path__ + "static/img/banner-04.c87c82c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/banner-04.png
// module id = 91QA
// module chunks = 1